var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpsMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2559 7.76182V4.50049H18.2559V7.7613C12.5608 8.01098 8.0137 12.5563 7.76107 18.2505H4.5V19.2505H7.76107C8.01376 24.9434 12.5608 29.4899 18.2559 29.7397V32.9998H19.2559V29.7392C24.9476 29.4836 29.4899 24.9359 29.7392 19.2439H32.9984V18.2439H29.7386C29.483 12.5567 24.9432 8.01712 19.2559 7.76182ZM8.75 18.7505C8.75 13.2111 13.2106 8.75049 18.75 8.75049C24.2894 8.75049 28.75 13.2111 28.75 18.7505C28.75 24.2884 24.2893 28.7505 18.75 28.7505C13.2107 28.7505 8.75 24.2884 8.75 18.7505ZM13.25 18.7505C13.25 15.7131 15.7126 13.2505 18.75 13.2505C21.7874 13.2505 24.25 15.7131 24.25 18.7505C24.25 21.7864 21.7873 24.2505 18.75 24.2505C15.7127 24.2505 13.25 21.7864 13.25 18.7505ZM18.75 12.2505C15.1604 12.2505 12.25 15.1608 12.25 18.7505C12.25 22.3386 15.1603 25.2505 18.75 25.2505C22.3397 25.2505 25.25 22.3386 25.25 18.7505C25.25 15.1608 22.3396 12.2505 18.75 12.2505Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsMedium);
export default __webpack_public_path__ + "static/media/gps-medium.793f5d7614cda475dd7f208ecbf29ca0.svg";
export { ForwardRef as ReactComponent };